import { Injectable } from '@angular/core';
import { AddressModels } from 'models/address.models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormsModels } from '../../../../models/forms.model';
import { AddressApiService } from './api/address-api.service';

@Injectable({
  providedIn: 'root',
})
export class AddressService {
  constructor(private apiService: AddressApiService) {}

  getCities(
    zipCode: string,
    addressRepo: 'wazari' | 'smalltox' = 'wazari',
  ): Observable<FormsModels.SelectListItem[]> {
    return this.apiService
      .getCities(
        zipCode,
        addressRepo === 'wazari'
          ? AddressModels.CitiesRepositoryEnum.TunnelSante
          : AddressModels.CitiesRepositoryEnum.Smalltox,
      )
      .pipe(
        map((cities) => {
          if (!cities) {
            return [];
          }

          return cities.map((city) => ({
            text: city.name,
            value: city.inseeCode,
          }));
        }),
      );
  }
}
